<template>
  <div class="custom-breadcrumb relative top-padding">
    <div class="wrap">
      <!-- 关键：用 <template #separator> 手动渲染图标 -->
      <el-breadcrumb :separator-icon="ArrowRight">
        <el-breadcrumb-item :to="{ path: '/' }">{{ t('common.home') }}</el-breadcrumb-item>
        <template v-for="(item, index) in crumbNav" :key="index">
          <el-breadcrumb-item v-if="index < crumbNav.length - 1" :to="item.path">
            {{ item.name }}
          </el-breadcrumb-item>
          <el-breadcrumb-item v-else>
            <h1 v-if="currentAsH1" class="crumb-h1">{{ item.name }}</h1>
            <template v-else>{{ item.name }}</template>
          </el-breadcrumb-item>
        </template>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { watch, ref } from 'vue'
// 1. 导入图标组件
import { ArrowRight } from '@element-plus/icons-vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
interface CrumbItem {
  /** 面包屑名称 */
  name?: string
  /** 面包屑路径 */
  path?: string
}

// Props 定义
const props = withDefaults(
  defineProps<{
    /** 面包屑列表 */
    crumbList?: CrumbItem[]
    /** SEO：当前页名称作为页面唯一 h1 */
    currentAsH1?: boolean
  }>(),
  {
    currentAsH1: false,
  }
)
import { useRoute } from 'vue-router'
const route = useRoute() // 当前路由
const getPurePath = () => {
  const path = route.path || ''
  // 去掉 /zh-CN /en-US 等
  return path.replace(/^\/[a-zA-Z-]+/, '').toLowerCase()
}
const crumbNav = ref<Array<CrumbItem>>([])
const matchRoute = (nav: any[]) => {
  crumbNav.value = []
  // 优先使用自定义面包屑
  if (props.crumbList && props.crumbList.length > 0) {
    crumbNav.value = props.crumbList
    return
  }
  const path = getPurePath()
  for (const nav1 of nav) {
    const nav1Link = nav1.link?.toLowerCase()
    // 先匹配子级
    if (nav1.childrenList?.length) {
      for (const nav2 of nav1.childrenList) {
        const nav2Link = nav2.link?.toLowerCase()
        if (path === nav2Link) {
          if (nav1Link  === nav2Link && nav1.name === nav2.name) {
            crumbNav.value = [{ name: nav2.name, path: nav2.link }]
          } else {
            crumbNav.value = [
              { name: nav1.name, path: nav1.link },
              { name: nav2.name, path: nav2.link }
            ]
          }
          return
        }
      }
    }
    // 再匹配父级
    if (path === nav1Link  || path.startsWith(nav1Link  + '/')) {
      crumbNav.value = [{ name: nav1.name, path: nav1.link }]
      return
    }
  }
}

const headNav = useState('headNav')
watch(
  () => headNav,
  () => {
    const nav = JSON.parse(JSON.stringify(headNav.value))
    if (headNav.value && headNav.value.length > 0) {
      setTimeout(() => {
        matchRoute(nav)
      }, 0)
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="scss" scoped>
// 2. 修复样式穿透目标，确保颜色生效
:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #fff !important;
    font-weight: 400;
    font-size: 16px;
  }
  .is-link {
    transition: all 0.3s;
    &:hover {
      opacity: 0.5;
    }
  }

  // 3. 控制箭头图标颜色和大小
  .el-breadcrumb__separator {
    font-size: 16px; // 箭头大小
    margin: 0 8px; // 箭头与文字间距
    color: #ffffff;
  }

  .el-breadcrumb__item {
    &:last-child {
      .el-breadcrumb__inner {
        font-weight: bold;
      }
    }
  }

  .crumb-h1 {
    display: inline;
    margin: 0;
    padding: 0;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
  }
}

@media (max-width: 767px) {
  :deep(.el-breadcrumb) {
    .el-breadcrumb__separator {
      font-size: 14px; // 箭头大小
      margin: 0 4px; // 箭头与文字间距
    }
  }
}

@media (max-width: 460px) {
  .custom-breadcrumb {
    padding-top: 86px;
  }
}
</style>
